var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gk-period-selector"},[_c('month-picker-input',{attrs:{"default-month":_vm.defaultPeriod.month,"default-year":_vm.defaultPeriod.year,"no-default":false,"lang":_vm.preferredLanguage},on:{"change":_vm.updateValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }